/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useListCaseType = makeQueryHook(operations.listCaseType)

export const useCreateCaseType = makeMutationHook(operations.createCaseType)

export const useInternalListCaseTypes = makeQueryHook(
  operations.internalListCaseTypes,
)

export const useGetCaseTypeById = makeQueryHook(operations.getCaseTypeById)

export const useUpdateCaseType = makeMutationHook(operations.updateCaseType)

export const useCaseTypeAddAssociation = makeMutationHook(
  operations.caseTypeAddAssociation,
)

export const useCaseTypeRemoveAssociation = makeMutationHook(
  operations.caseTypeRemoveAssociation,
)

export const useCreateSmartReviewTasks = makeMutationHook(
  operations.createSmartReviewTasks,
)

export const useInternalCreateCaseTypeSmartReviewTasks = makeMutationHook(
  operations.internalCreateCaseTypeSmartReviewTasks,
)

export const useListCasesByCompany = makeQueryHook(
  operations.listCasesByCompany,
)

export const useListCasesByBorrower = makeQueryHook(
  operations.listCasesByBorrower,
)

export const useCreateCase = makeMutationHook(operations.createCase)

export const useGetCaseById = makeQueryHook(operations.getCaseById)

export const useUpdateCase = makeMutationHook(operations.updateCase)

export const useAddCaseAssociation = makeMutationHook(
  operations.addCaseAssociation,
)

export const useRemoveCaseAssociation = makeMutationHook(
  operations.removeCaseAssociation,
)

export const useCaseEscalationsGet = makeQueryHook(
  operations.caseEscalationsGet,
)

export const useCaseEscalationsCreate = makeMutationHook(
  operations.caseEscalationsCreate,
)

export const useCaseEscalationGetById = makeQueryHook(
  operations.caseEscalationGetById,
)

export const useCaseOpenEscalationsGetByCompany = makeQueryHook(
  operations.caseOpenEscalationsGetByCompany,
)

export const useViewCase = makeMutationHook(operations.viewCase)

export const useInternalListCasesByCompany = makeQueryHook(
  operations.internalListCasesByCompany,
)

export const useInternalUnboundGetCaseById = makeQueryHook(
  operations.internalUnboundGetCaseById,
)

export const useInternalUnboundCaseUpdate = makeMutationHook(
  operations.internalUnboundCaseUpdate,
)

export const useInternalUnboundAddCaseAssociation = makeMutationHook(
  operations.internalUnboundAddCaseAssociation,
)

export const useInternalUnboundRemoveCaseAssociation = makeMutationHook(
  operations.internalUnboundRemoveCaseAssociation,
)

export const useInternalListCasesByBorrower = makeQueryHook(
  operations.internalListCasesByBorrower,
)

export const useInternalCreateCase = makeMutationHook(
  operations.internalCreateCase,
)

export const useInternalGetCaseById = makeQueryHook(
  operations.internalGetCaseById,
)

export const useInternalUpdateCase = makeMutationHook(
  operations.internalUpdateCase,
)

export const useInternalAddCaseAssociation = makeMutationHook(
  operations.internalAddCaseAssociation,
)

export const useInternalRemoveCaseAssociation = makeMutationHook(
  operations.internalRemoveCaseAssociation,
)

export const useInternalGetCaseEscalation = makeQueryHook(
  operations.internalGetCaseEscalation,
)

export const useInternalCreateCaseEscalation = makeMutationHook(
  operations.internalCreateCaseEscalation,
)

export const useInternalCaseOpenEscalationsGetByCompany = makeQueryHook(
  operations.internalCaseOpenEscalationsGetByCompany,
)

export const useCreateTaskFromNote = makeMutationHook(
  operations.createTaskFromNote,
)
